// removed by extract-text-webpack-plugin
module.exports = {"loading":"preloader-module_loading_2_X14"};


//////////////////
// WEBPACK FOOTER
// ./client/components/productList/preloader/preloader.module.css
// module id = 302
// module chunks = 1 2 3